import { render, staticRenderFns } from "./RecipientEmail.vue?vue&type=template&id=eb8dee22"
import script from "./RecipientEmail.vue?vue&type=script&lang=js"
export * from "./RecipientEmail.vue?vue&type=script&lang=js"
import style0 from "./RecipientEmail.vue?vue&type=style&index=0&id=eb8dee22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports